import { useState, useEffect } from "react";
import { apiFetch } from "../../../context/AuthContext";

const useTodos = (BASE_URL, currentInfinityCode) => {
  const [todos, setTodos] = useState([]);

  useEffect(() => {
    const fetchTodos = async () => {
      if (!currentInfinityCode) return;
      try {
        const response = await apiFetch(`${BASE_URL}/todos/${currentInfinityCode}`, {
          method: "GET",
        });
        const data = await response.json();
        setTodos(data.todos || []);
      } catch (error) {
        console.error("Error fetching todos:", error);
      }
    };

    fetchTodos();
  }, [currentInfinityCode]);

  const addTodo = async (e, newTodoText, todoCategory, setNewTodoText) => {
    e.preventDefault();
    if (!newTodoText.trim()) return;

    try {
      const response = await apiFetch(`${BASE_URL}/todos`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          infinityCode: currentInfinityCode,
          text: newTodoText.trim(),
          category: todoCategory,
        }),
      });
      const data = await response.json();
      setTodos((prev) => [data.todo, ...prev]);
      setNewTodoText("");
    } catch (error) {
      console.error("Error adding todo:", error);
    }
  };

  const toggleTodo = async (id) => {
    try {
      const todo = todos.find((t) => t.id === id);
      const response = await apiFetch(`${BASE_URL}/todos/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ completed: !todo.completed }),
      });
      const data = await response.json();
      setTodos((prev) => prev.map((t) => (t.id === id ? data.todo : t)));
    } catch (error) {
      console.error("Error toggling todo:", error);
    }
  };

  const deleteTodo = async (id) => {
    try {
      await apiFetch(`${BASE_URL}/todos/${id}`, { method: "DELETE" });
      setTodos((prev) => prev.filter((t) => t.id !== id));
    } catch (error) {
      console.error("Error deleting todo:", error);
    }
  };

  const getFilteredTodos = (todoFilter) => {
    if (todoFilter === "active") return todos.filter((t) => !t.completed);
    if (todoFilter === "completed") return todos.filter((t) => t.completed);
    return todos;
  };

  const getTodoStats = () => {
    const total = todos.length;
    const completed = todos.filter((t) => t.completed).length;
    const progress = total > 0 ? Math.round((completed / total) * 100) : 0;
    return { total, completed, active: total - completed, progress };
  };

  return {
    todos,
    setTodos,
    addTodo,
    toggleTodo,
    deleteTodo,
    getFilteredTodos,
    getTodoStats,
  };
};

export default useTodos;
